import {createNamespacedHelpers} from 'vuex'
import _ from 'lodash'
import $ from '../shared/helper'
import {CONST} from '../shared/constants'
import {ATYPES, MAP_GETTERS} from './types'

const {mapGetters} = createNamespacedHelpers(CONST.NAMESPACE)

//
// build getter/setter for mapGetters
//
export const mapSetter = (state, setters = {}) =>
  Object.keys(state).reduce((acc, stateName) => {
    acc[stateName] = {get: state[stateName]}
    if (setters[stateName]) acc[stateName].set = setters[stateName]
    return acc
  }, {})

//
// context for 'this' is always the component who inject the gridform computed methods
// NOTE the component need a dispatch method which wrap to the correct vuex namespace
//
export const gfComputed = {
  ...mapSetter(mapGetters(MAP_GETTERS), {
    dark(dark) {
      dark = $.bool(dark, false)
      this.dispatch(ATYPES.GFCONFIG, {dark})
    },
    size(size) {
      if (!_.inRange(size, CONST.SIZE_MIN - 1, CONST.SIZE_MAX + 1)) size = CONST.SIZE_DEFAULT
      this.dispatch(ATYPES.GFCONFIG, {
        size,
        stacked: size <= CONST.SIZE_STACKED
      })
    },
    fieldstyle(fieldstyle) {
      if (!_.includes(CONST.FIELD_STYLES, fieldstyle)) fieldstyle = CONST.FIELD_STYLES[0]
      this.dispatch(ATYPES.GFCONFIG, {fieldstyle})
    }
  })
}
